import React, { useEffect } from "react";
import { Button, Form, Input, Select, Row, Col, Typography, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const { Title } = Typography;
const { Option } = Select;

function UpdateClient() {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("access-token");

  // Fetch client by ID
  useEffect(() => {
    const fetchClient = async () => {
      try {
        const res = await axios.get(`https://rhrmapi.up2dateinc.com/api/clients/${id}`, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });

        if (res.data && typeof res.data === "object") {
          form.setFieldsValue(res.data); // Populate the form
        } else {
          message.error("Failed to load client data");
        }
      } catch (err) {
        console.error(err);
        message.error("Failed to fetch client");
      }
    };

    fetchClient();
  }, [id, form, accessToken]);

  // Update client
  const updateClient = async (values) => {
    try {
      await axios.put(`https://rhrmapi.up2dateinc.com/api/clients/${id}`, values, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      message.success("Client updated successfully");
      navigate("/admin/manage-clients");
    } catch (err) {
      console.error(err);
      message.error("Failed to update client");
    }
  };

  return (
    <div>
      <Title level={3}>Update Client</Title>

      <Form layout="vertical" form={form} onFinish={updateClient}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="name" label="Client Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="country" label="Country" rules={[{ required: true }]}>
              <Select>
                <Option value="India">India</Option>
                <Option value="United States">United States</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="email" label="Email Address" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="company" label="Company" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name="address" label="Address" rules={[{ required: true }]}>
              <Input.TextArea rows={3} />
            </Form.Item>
          </Col>
        </Row>

        <Button type="primary" htmlType="submit">
          Update Client
        </Button>
      </Form>
    </div>
  );
}

export default UpdateClient;